var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergocapitalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 80,
    viewBox: "0 0 323 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0135 48.3298V26.3717L16.2294 23H24.2692V30.9581H30.1018L37.1728 38.3717V46.3089H42.1065V57H0V45.4503L7.66028 37.4188C8.06976 36.9895 8.75888 37.2932 8.75888 37.8901V48.3194H13.0135V48.3298Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6027 48.3298H12.9937V57H21.6027V48.3298Z",
    fill: "#5DC5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0459 36.424H24.8685L30.0819 30.958H24.2693L19.0459 36.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2654 42.3926H21.6025V48.3298H27.2654V42.3926Z",
    fill: "#5DC5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8228 47.5339C59.6143 47.5339 58.3859 47.2302 57.6867 46.6019V50.3611C58.8053 50.8951 60.0537 51.1569 61.2922 51.1569C64.8676 51.1569 68.3033 49.1883 68.3033 44.3716C68.3232 39.3454 64.8576 37.314 61.392 37.314C60.0937 37.314 58.7953 37.5757 57.6768 38.1098V41.7956C58.4358 41.2616 59.6642 40.9056 60.7928 40.9056C62.2909 40.9265 63.5893 41.3663 64.0786 42.8323H59.4944V45.7223H64.1086C63.5793 47.0208 62.3209 47.5234 60.8128 47.5234L60.8228 47.5339Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8086 50.8638H75.9733V46.1517H80.3477V50.8638H84.4925V37.6282H80.3477V42.3402H75.9733V37.6282H71.8086V50.8638Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.385 41.0732V37.6282H88.8271V50.8638H98.4949V47.3873H92.9919V45.8167H97.7358V42.602H92.9919V41.0732H98.385Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.016 41.4502H126.31V37.6282H116.842V50.8638H121.016V41.4502Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.162 37.6281H102.3V50.8637H106.415V47.7957H109.162C111.838 47.7957 114.015 45.513 114.015 42.7067C114.015 39.9004 111.838 37.6177 109.162 37.6177V37.6281ZM108.722 44.1622H106.415V41.2617H108.722C109.481 41.2617 110.11 41.9109 110.11 42.7067C110.11 43.5025 109.491 44.1622 108.722 44.1622Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.689 51.335C138.414 51.335 141.451 48.1517 141.451 44.246C141.451 40.3402 138.414 37.157 134.689 37.157C130.964 37.157 127.928 40.3402 127.928 44.246C127.928 48.1517 130.964 51.335 134.689 51.335ZM134.689 41.1465C136.257 41.1465 137.526 42.5392 137.526 44.246C137.526 45.9528 136.247 47.3455 134.689 47.3455C133.131 47.3455 131.853 45.9528 131.853 44.246C131.853 42.5392 133.131 41.1465 134.689 41.1465Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.455 37.6282V41.4502H315.15V50.8638H319.305V41.4502H323V37.6282H311.455Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.745 44.1831L157.59 37.6282H152.726L150.199 42.3193H148.482V37.6282H144.317V50.8638H148.482V46.1308H150.11L152.796 50.8638H157.66L153.745 44.1831Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.296 41.1046C272.414 41.1046 273.563 41.5025 274.272 42.0156V38.1203C273.153 37.5862 271.855 37.3245 270.557 37.3245C267.091 37.3245 263.636 39.3454 263.646 44.3821C263.646 49.1988 267.091 51.1674 270.657 51.1674C271.995 51.1674 273.233 50.9056 274.352 50.3716V46.3821C273.703 46.9894 272.494 47.3245 271.196 47.3245C269.538 47.3245 267.91 46.4554 267.91 44.3716C267.91 42.0051 269.548 41.1046 271.286 41.1046H271.296Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.461 37.6282H175.817V50.8638H179.962V41.4502H184.306V50.8638H188.461V37.6282Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.526 50.8638V41.4502H219.222V37.6282H207.676V41.4502H211.372V50.8638H215.526Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.245 50.8638H173.47L168.746 37.6282H164.291L159.567 50.8638H163.792L164.351 49.1046H168.696L169.255 50.8638H169.245ZM165.35 45.9528L166.519 42.2879L167.687 45.9528H165.35Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.819 50.8638H233.044L228.32 37.6282H223.866L219.142 50.8638H223.366L223.926 49.1046H228.27L228.829 50.8638H228.819ZM224.924 45.9528L226.093 42.2879L227.261 45.9528H224.924Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.8 37.6282H201.285L196.101 44.7591V37.6282H191.937V50.8638H195.452L200.635 43.7329V50.8638H204.8V37.6282Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.209 37.6282H304.044V50.8638H308.209V37.6282Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.391 40.6962H296.014V37.6282H292.009V50.8638H298.381C301.058 50.8638 303.235 48.5811 303.235 45.7748C303.235 42.9685 301.058 40.6858 298.381 40.6858L298.391 40.6962ZM297.952 47.2303H296.014V44.3297H297.952C298.711 44.3297 299.34 44.979 299.34 45.7852C299.34 46.5915 298.721 47.2303 297.952 47.2303Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.845 50.8638V37.6282H239.466L234.822 50.8638H239.206L242.512 41.4502H243.681V50.8638H247.845Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.358 42.4449H281.942V41.1256H287.745V37.6282H277.768V50.8638H285.348C287.565 50.8638 289.363 48.979 289.363 46.6544C289.363 44.3297 287.565 42.4449 285.348 42.4449H285.358ZM284.869 47.7224H281.942V45.5758H284.869C285.438 45.5758 285.897 46.0575 285.897 46.6439C285.897 47.2303 285.438 47.7119 284.869 47.7119V47.7224Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.802 42.7485H252.54V45.7328H258.802V42.7485Z",
    fill: "#283581"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 34,
    fill: "white",
    transform: "translate(0 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergocapitalLogo);
export default __webpack_public_path__ + "static/media/energocapital_logo.002982d343f00099534d729e10b148a8.svg";
export { ForwardRef as ReactComponent };